import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import AppBaqueiraHeader from '../containers/AppBaqueiraHeader'
import { withNamespaces } from "react-i18next"
import StepBarBaqueira from '../components/StepBarBaqueira'
import { MapPin } from 'lucide-react'
import { fetchAvailability, postCancelPrebooking } from '../actions/qrs'

class ZoneSelectorBaqueiraView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      zones: null,
      description: null,
      customerName: null,
      forwardScreen: false,
      machineSleeping: false
    }

    this.goTo = this.goTo.bind(this)
  }

  goTo(zoneNumber, descriptionZone, e) {
    const { id } = this.props.match.params
    const { qrMode } = this.props.location.state

    this.setState({ forwardScreen: true }, () => {
      history.push('/lockerSelectorBaqueiraView', {
        zoneSelected: zoneNumber,
        descriptionZone: descriptionZone,
        qr: id,
        customerName: this.state.customerName,
        qrMode: qrMode
      })
    })
  }

  componentDidMount() {
    const { id } = this.props.match.params

    const navigationEntries = window.performance.getEntriesByType('navigation')
    if ((navigationEntries.length > 0) && (navigationEntries[0].type === 'reload')) {
      console.log("Page was reloaded")
    }

    const now = new Date()
    const spainTime = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Madrid',
      hour: 'numeric',
      hour12: false,
    }).formatToParts(now)

    const hour = parseInt(spainTime.find(part => part.type === 'hour').value, 10)

    if ((hour === 23) || (hour === 0)) {
      this.setState({ machineSleeping: true })
      return
    }

    this.props.fetchAvailability(id)
      .then((answer) => {
        const answerZones = answer.response.answerZones

        if (answerZones.multipleZones) {
          this.setState({
            zones: answerZones.multipleZones,
            description: answerZones.descriptionZones
          })
        } else if (answerZones.singleZone) {
          this.goTo(answerZones.singleZone, answerZones.descriptionZones[answerZones.singleZone - 1], 0)
        }

        this.setState({ customerName: answerZones.customerName })
      })
      .catch((error) => {
        console.error(error)
      })
  }

  renderZoneCards() {
    const { t } = this.props
    const { zones, description } = this.state

    if (!zones || !description) {
      return (
        <div className="bq-spinner">
          <img src="/images/logo_baqueira.png" alt="Logo" />
        </div>
      )
    }

    return (
      <div className="bq-zone-grid">
        {zones.sort((a, b) => a - b).map((zone) => (
          <div
            key={zone}
            className="bq-zone-card"
            onClick={(e) => this.goTo(zone, description[zone - 1], e)}
          >
            <div className="bq-zone-card-icon">
              <MapPin size={26} />
            </div>
            <span className="bq-zone-card-number">{t('ZONA ') + zone}</span>
            <p className="bq-zone-card-desc">{t(description[zone - 1])}</p>
          </div>
        ))}
      </div>
    )
  }

  renderSleepingMessage() {
    const { t } = this.props

    return (
      <div className="baqueiraBackground">
        <AppBaqueiraHeader />
        <div className="nm-page">
          <div className="bq-sleeping-msg">
            <h3 className="bq-sleeping-msg-title">{t('Fuera de horario')}</h3>
            <p>{t('Lo sentimos, pero la venta no está disponible entre las 23:00h y la 01:00h, vuelva fuera de este horario.')}</p>
            <img src="/images/sleeping_machine.webp" alt="Sleeping Machine"
              style={{ width: '75%', maxWidth: 320, display: 'block', margin: '1.5rem auto 0' }} />
          </div>
        </div>
        <StepBarBaqueira step={1} />
      </div>
    )
  }

  render() {
    const { t } = this.props
    const { customerName, machineSleeping } = this.state

    if (machineSleeping) {
      return this.renderSleepingMessage()
    }

    return (
      <div className="baqueiraBackground">
        <AppBaqueiraHeader />
        <div className="nm-page">
          <div className="bq-zone-header">
            <span className="bq-zone-header-welcome">{t('BIENVENIDO A')}</span>
            <h1 className="bq-zone-header-name">{customerName || 'BAQUEIRA BERET'}</h1>
            <p className="bq-zone-header-sub">{t('SELECCIONA LA ZONA DE TAQUILLAS')}</p>
          </div>

          {this.renderZoneCards()}
        </div>
        <StepBarBaqueira step={1} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: true,
  availability: state.availability
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  fetchAvailability: bindActionCreators(fetchAvailability, dispatch),
  postCancelPrebooking: bindActionCreators(postCancelPrebooking, dispatch)
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(ZoneSelectorBaqueiraView))
